module.exports = __webpack_public_path__ + "img/triangle2blue.e58fcc8d.png";